import { IconBaseProps, IconType } from 'react-icons';

type IconProps = IconBaseProps & {
  icon: IconType;
};

function Icon({ icon, ...props }: IconProps) {
  return <>{icon(props)}</>;
}

export default Icon;
